/**
 * This method generates the schema for the product offer that is used in the product and collectionPage schema.
 */
export const generateProductOfferSchema = (prices: { minDays: number, price: number }[]) => {
  let offers: Record<string, string | number> = {};

  if (!prices || 0 === prices.length) {
    return offers;
  }

  offers = {
    '@type': 'Offer',
    'availability': 'https://schema.org/InStock',
    price: (prices?.reduce(function (prev, curr) {
      return prev.price < curr.price ? prev : curr;
    })?.price ?? 0) / 100,
    lowPrice: (prices?.reduce(function (prev, curr) {
      return prev.price < curr.price ? prev : curr;
    })?.price ?? 0) / 100,
    highPrice: (prices?.reduce(function (prev, curr) {
      return prev.price > curr.price ? prev : curr;
    })?.price ?? 0) / 100,
    'priceCurrency': 'EUR',
    'businessFunction': 'http://purl.org/goodrelations/v1#LeaseOut',
  };

  return offers;
}
